import React from 'react';
import { Head } from '@ecommerce/nest-ssr/components';
import { SeoDataInterface } from 'modules/seo-module/interfaces/seo-data.interface';

const ProducerHead: React.FC<{
    robotsContent: SeoDataInterface['robotsContent'];
}> = ({
    robotsContent
}) => {
    return (
        <Head>
            <meta name="robots" content={robotsContent} />
        </Head>
    );
};

export default ProducerHead;
